// src/auth/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const isGuest = localStorage.getItem("guest") === "true";
  const currentPath = window.location.pathname;

  // ✅ Pages that guests are allowed to visit
  const guestAllowed = ["/dashboard", "/create", "/payment", "/success"];

  // 🧹 If real token exists, clear any old guest flags
  if (token && isGuest && token.includes(".")) {
    localStorage.removeItem("guest");
  }

  // ✅ Allow guests before any JWT validation
  if (isGuest) {
    if (guestAllowed.some((r) => currentPath.startsWith(r))) {
      return children; // let guest continue
    } else {
      return <Navigate to="/dashboard" replace />; // restrict guest to allowed pages
    }
  }

  // 🚫 Not guest and no token at all → must login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // 🧠 Only decode if token looks like a proper JWT
  if (token.includes(".")) {
    try {
      const decoded = jwtDecode(token);

      // ⏰ Optional expiration check
      if (decoded.exp && decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        return <Navigate to="/login" replace />;
      }

      // 📧 Optional verification flag
      if (decoded?.isVerified === false) {
        return <Navigate to="/verify-notice" replace />;
      }

      // ✅ Valid user
      return children;
    } catch (err) {
      console.warn("JWT decode failed:", err);
      localStorage.removeItem("token");
      return <Navigate to="/login" replace />;
    }
  }

  // 🚫 If token is malformed and not guest
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;